export const employees = [
  {
    id: 1,
    name: "Trần Viễn",
    code: "0KHOHCM042",
    phone: "0987654321",
    email: "tranvien@example.com",
    position: "CEO - Giám đốc điều hành",
    departmentId: 1,
    status: "active",
  },
  {
    id: 2,
    name: "Nguyễn Mai Phương",
    code: "0TLHCM042",
    phone: "0901234567",
    email: "maiphuong@example.com",
    position: "CTO",
    departmentId: 3,
    status: "active",
  },
  {
    id: 3,
    name: "Phan Ken",
    code: "0TLHCM061",
    phone: "0912345678",
    email: "phanken@example.com",
    position: "Giám đốc Marketing",
    departmentId: 3,
    status: "active",
  },
  {
    id: 4,
    name: "Lê Thanh Tùng",
    code: "0MKT002",
    phone: "0934567890",
    email: "letung@example.com",
    position: "Nhân viên Marketing",
    departmentId: 3,
    status: "active",
  },
  {
    id: 5,
    name: "Đặng Minh Huy",
    code: "0KT001",
    phone: "0976543210",
    email: "minhhuy@example.com",
    position: "Kế toán trưởng",
    departmentId: 2,
    status: "active",
  },
  {
    id: 6,
    name: "Phạm Thị Thu",
    code: "0KT002",
    phone: "0956781234",
    email: "phamthu@example.com",
    position: "Nhân viên kế toán",
    departmentId: 2,
    status: "active",
  },
];
